<template>
  <div>
    <el-form size="small">
      <el-form-item style="margin-left:29px">
        <el-date-picker value-format="timestamp" :clearable="false" style="width:160px;margin-right:8px" v-model="startTime" type="date" placeholder="选择日期" />
        <span>日</span>
        <span style="color:rgba(0,0,0,.65)">（默认今天）</span>
      </el-form-item>
      <el-form-item>
        <span style="color:rgba(0,0,0,.85)">距</span>
        <el-date-picker value-format="timestamp" style="width:160px;margin:0 8px 0 10px" :picker-options="pickerOptions" v-model="endTime" type="date" placeholder="选择日期" @change="changeTime" />
        <span>日</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDiffValues">计算日期</el-button>
        <span style="color:rgba(0,0,0,.85);padding-left:16px">
          相差：<span v-if="diffDaysValue">{{ diffDaysValue }}</span>
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'DateDiff',
  data() {
    return {
      startTime: new Date().getTime(),
      endTime: '',
      diffDaysValue: '',
    }
  },
  computed: {
    pickerOptions() {
      var _this = this
      return {
        disabledDate(time) {
          return time < _this.startTime
        },
      }
    },
  },
  methods: {
    changeTime() {
      if (!this.endTime) this.diffDaysValue = ''
    },
    getDiffValues() {
      if (!this.endTime) {
        this.$message.error('请选择需要计算的日期')
        return
      }
      let diffDays = ''
      let diffWeeks = ''
      let diffMonths = ''
      let weekNums = 0
      let weekDays = 0
      let monthNum = 0
      let monthDays = 0
      diffDays = Math.ceil((this.endTime - this.startTime) / (3600 * 24 * 1000))
      const yearStart = new Date(this.startTime).getFullYear()
      const yearEnd = new Date(this.endTime).getFullYear()
      const monthStart = new Date(this.startTime).getMonth() + 1
      const monthEnd = new Date(this.endTime).getMonth() + 1
      const dateStart = new Date(this.startTime).getDate()
      const dateEnd = new Date(this.endTime).getDate()
      if (diffDays > 0) {
        weekNums = Math.floor(diffDays / 7)
        weekDays = diffDays % 7
        monthNum = (yearEnd - yearStart) * 12 + (monthEnd - monthStart)
        if (dateEnd >= dateStart) {
          monthDays = dateEnd - dateStart
        } else {
          monthNum--
          let daytemp = new Date(yearEnd, monthEnd - 2, dateStart)
          monthDays = (dateEnd - daytemp) / 86400000
        }
      }
      diffWeeks = weekNums > 0 ? ' = ' + weekNums + ' 星期 ' : ''
      diffWeeks += weekNums > 0 ? weekDays + ' 天 ' : ''
      diffMonths = monthNum > 0 ? ' = ' + monthNum + ' 个月 ' : ''
      diffMonths += monthNum > 0 ? monthDays + ' 天 ' : ''
      this.diffDaysValue = `${diffDays} 天 ${diffWeeks} ${diffMonths}`
    },
  },
}
</script>
